export default "__VITE_ASSET__BwZuSLzW__"